import {
  ACCSETTING_LOADING,
  GET_ACCSETTING,
  GET_ACCSETTING_SUCCESS,
  GET_ACCSETTING_FAIL,
  ADD_ACCSETTING_SUCCESS,
  ADD_ACCSETTING_FAIL,
  DELETE_ACCSETTING_SUCCESS,
  DELETE_ACCSETTING_FAIL,
  UPDATE_ACCSETTING_SUCCESS,
  UPDATE_ACCSETTING_FAIL,
  ACCSETTING_RESET
} from "./actionType";

const INIT_STATE = {
  accSettings: [],
  error: {},
};

const AccSetting = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ACCSETTING_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ACCSETTING:
          return {
            ...state,
            accSettings: action.payload.data,
            isAccSettingCreated: false,
            isAccSettingSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ACCSETTING_FAIL:
      switch (action.payload.actionType) {
        case GET_ACCSETTING_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAccSettingCreated: false,
            isAccSettingSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ACCSETTING: {
      return {
        ...state,
        isAccSettingCreated: false,
        loading: true,
      };
    }

    case ACCSETTING_LOADING: {
      return {
        ...state,
        isAccSettingCreated: false,
        loading: true,
      };
    }

    case ADD_ACCSETTING_SUCCESS:
      return {
        ...state,
        isAccSettingCreated: true,
        loading: false,
        accSettings: action.payload.data,
      };

    case ADD_ACCSETTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ACCSETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        accSettings: action.payload.data,
      };

    case DELETE_ACCSETTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ACCSETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        accSettings: action.payload.data,
      };

    case UPDATE_ACCSETTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACCSETTING_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default AccSetting;